import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Blog, BlogSingle } from "../../../Constant";
import { SingleBlogData } from "./SingleBlogData";
import CommentSection from "./CommentSection";

const BlogSingleContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={BlogSingle} parent={Blog} title={BlogSingle} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <div className="blog-single">
              <SingleBlogData/>
              <CommentSection/>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BlogSingleContainer;
